<template>
  <div>
    <!--    <div class="card" v-if="!emailVerified">-->
    <!--      <div class="card-body p-4 p-md-5">-->
    <!--        <div>-->
    <!--          Vážený klient pre overenie Vašej emailovej adresy a telefónneho čísla-->
    <!--          sme Vám zaslali e-mail a SMS.-->
    <!--        </div>-->
    <!--&lt;!&ndash;          <div class="col-12 col-lg-3 text-center text-lg-right mt-3 mt-lg-0">&ndash;&gt;-->
    <!--&lt;!&ndash;            <button class="btn btn-highlighted  mr-1" @click="reload">&ndash;&gt;-->
    <!--&lt;!&ndash;              <font-awesome-icon icon="redo" class="mr-2" />&ndash;&gt;-->
    <!--&lt;!&ndash;              Obnoviť stránku&ndash;&gt;-->
    <!--&lt;!&ndash;            </button>&ndash;&gt;-->
    <!--&lt;!&ndash;          </div>&ndash;&gt;-->
    <!--      </div>-->
    <!--    </div>-->
    <form
      class="personal-info-form"
      @submit.prevent="savePersonalInfo"
      ref="form"
    >
      <div class="card mb-4">
        <div class="card-body p-4 p-md-5">
          <div class="mb-4">
            <h5 class="text-highlighted">Overenie emailu a telefónneho čísla</h5>
            <div>
              Vážený klient, pre overenie Vašej emailovej adresy a telefónneho
              čísla sme Vám zaslali e-mail a SMS.
            </div>
          </div>

          <div class="form-field row">
            <div class="col-12 col-lg-4">
              <input
                class="form-control"
                type="text"
                placeholder="Zadajte emailový kód"
                v-model="formModel.email_code"
                required
              />
            </div>
            <div class="col-12 col-lg-4">
              <input
                class="form-control"
                type="text"
                placeholder="Zadajte SMS kód"
                v-model="formModel.sms_code"
                required
              />
            </div>
            <div class="col-12 col-lg-4">
              <div class="btn btn-highlighted w-100" @click="sendSms">
                Znova zaslať SMS kód
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card"
        :class="formModel.person_type_id === 1 ? 'mb-1' : 'mb-4'"
      >
        <div class="card-body p-4 p-md-5">
          <div class="mb-4">
            <h5 class="text-highlighted">Vaše osobné údaje</h5>
          </div>
          <div class="mt-4">
            <b-form-group class="text-center mb-4">
              <b-form-radio-group
                v-model="formModel.person_type_id"
                button-variant="outline-highlighted"
                name="radios-btn-default"
                buttons
                :class="isMobile ? 'col-12 px-0' : ''"
                :stacked="isMobile"
              >
                <b-form-radio :value="1"
                  ><font-awesome-icon
                    icon="user"
                    class="mr-2"
                  />Jednotlivec</b-form-radio
                >
                <b-form-radio :value="2"
                  ><font-awesome-icon
                    icon="building"
                    class="mr-2"
                  />Spoločnosť</b-form-radio
                >
                <b-form-radio :value="3"
                  ><font-awesome-icon
                    icon="child"
                    class="mr-2"
                  />Dieťa</b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>

            <div v-if="formModel.person_type_id === 1">
              <form-group v-model="formModel" :fields="personal" />
            </div>
            <div v-if="formModel.person_type_id === 2">
              <form-group v-model="formModel" :fields="company" />
            </div>
            <div v-if="formModel.person_type_id === 3">
              <form-group v-model="formModel" :fields="child" />
            </div>

            <div>
              <hr />
              <h3 class="text-highlighted">Adresa</h3>
            </div>
            <div class="row">
              <div class="col-md-9 offset-1"></div>
            </div>
            <form-group
              v-if="countries"
              v-model="formModel"
              :fields="address"
            />

            <div>
              <hr />
              <h3 class="text-highlighted">Bankové spojenie</h3>
            </div>
            <form-group v-model="formModel" :fields="bankAccount" />
          </div>
        </div>
      </div>
      <div class="card mb-1" v-if="formModel.person_type_id !== 1">
        <div class="card-body p-4 p-md-5">
          <div class="mb-4">
            <h5 class="text-highlighted">
              {{
                formModel.person_type_id === 3
                  ? "Zákonný zástupca"
                  : "Oprávnená osoba"
              }}
            </h5>
          </div>
          <form-group
            v-model="formModel.client_owner"
            :fields="client_owner.personal"
          />

          <div>
            <hr />
            <h3 class="text-highlighted">Adresa</h3>
          </div>
          <form-group
            v-model="formModel.client_owner"
            :fields="client_owner.address"
          />
        </div>
      </div>
      <input ref="submit" type="submit" hidden />
    </form>
  </div>
</template>

<script>
import FormGroup from "./form/FormGroup";
import swiftCodes from "./SwiftCodes";

export default {
  name: "PersonalInfoForm",
  components: {
    FormGroup
  },
  mounted() {
    this.$store.dispatch("onboarding/getCountries");
    this.$parent.$emit("can-continue", { value: true });
  },
  computed: {
    isMobile() {
      return this.$parent.$parent.isMobile;
    },
    countries() {
      return this.$store.state.onboarding.countries;
    }
    // emailVerified() {
    //   return this.$store.state.onboarding.personalInfo.email_verified;
    // }
  },
  watch: {
    "formModel.iban"() {
      const iban = this.formModel.iban;
      const swiftEl = document.getElementById("swiftCode");
      swiftEl.disabled = true;
      if (iban.length > 8) {
        if (this.formModel.iban.toUpperCase().includes("SK")) {
          const code = iban.substring(5, 9);
          this.formModel.swift = swiftCodes[code];
        } else {
          swiftEl.disabled = false;
        }
      } else {
        this.formModel.swift = "";
      }
    }
    // emailVerified() {
    //   if (this.emailVerified) {
    //     this.$parent.$emit("can-continue", { value: true });
    //   } else {
    //     this.$parent.$emit("can-continue", { value: false });
    //   }
    // }
  },
  methods: {
    reload() {
      window.location.reload();
    },
    getCountries() {
      return this.countries;
    },
    sendSms() {
      this.$store.dispatch("onboarding/sendPinCode");
    },
    submit() {
      this.$refs.submit.click();
      return this.$refs.form.checkValidity();
    },
    savePersonalInfo() {
      if (
        this.formModel.person_type_id !== 2 &&
        this.formModel.birthnumber.length < 11
      ) {
        this.$store.dispatch(
          "alert/warning",
          "Nesprávny formát rodného čísla."
        );
      } else if (
        this.formModel.person_type_id !== 1 &&
        this.formModel.client_owner.birthnumber.length < 11
      ) {
        this.$store.dispatch(
          "alert/warning",
          "Nesprávny formát rodného čísla oprávnenej osoby."
        );
      } else {
        this.$parent.$parent.loading = true;
        this.$store
          .dispatch("onboarding/savePersonalInfo", this.formModel)
          .then(() => {
            this.$parent.$parent.loading = false;
            this.$parent.$parent.nextStep();
          })
          .catch(() => {
            this.$parent.$parent.loading = false;
          });
      }
    }
  },
  data() {
    return {
      verification: {
        pin: ""
      },
      // countries: [],
      formModel: {
        email_code: "",
        sms_code: "",
        person_type_id: 1,
        academic_title_before: "",
        name: "",
        surname: "",
        academic_title_after: "",
        birthdate: "",
        idcard_type_id: 2,
        idcard_no: "",
        idcard_validity: "",
        birthnumber: "",
        tax_residence_id: "3",
        companyName: "",
        company_name: "",
        company_idno: "",
        company_vat: "",
        street: "",
        city: "",
        zip: "",
        country_id: "3",
        bank_account_owner_name: "",
        iban: "",
        swift: "",
        bank_account_currency_id: 1,
        client_owner: {
          name: "",
          surname: "",
          birthnumber: "",
          idcard_no: "",
          street: "",
          city: "",
          zip: "",
          country_id: "3"
        }
      },
      personal: [
        {
          label: "Titul",
          placeholder: "Zadajte titul",
          model: "academic_title_before",
          formWrapperClass: "col-md-6 col-lg-2",
          required: false
        },
        {
          label: "Meno",
          placeholder: "Zadajte meno",
          model: "name",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        },
        {
          label: "Priezvisko",
          placeholder: "Zadajte priezvisko",
          model: "surname",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        },
        {
          label: "Titul za menom",
          placeholder: "Zadajte titul",
          model: "academic_title_after",
          formWrapperClass: "col-md-6 col-lg-2",
          required: false
        },
        {
          label: "Dátum narodenia",
          placeholder: "Vyberte dátum",
          model: "birthdate",
          formWrapperClass: "col-md-6 col-lg-3",
          type: "date",
          required: true
        },
        {
          label: "Rodné číslo",
          placeholder: "Zadajte rodné číslo",
          model: "birthnumber",
          formWrapperClass: "col-md-6 col-lg-5",
          mask: "######/####",
          required: true
        },
        {
          label: "Daňová rezidencia",
          placeholder: "Vyberte daňovú rezidenciu",
          model: "tax_residence_id",
          formWrapperClass: "col-md-6 col-lg-4",
          type: "select",
          options: () => {
            return this.countries;
          },
          required: true
        },
        {
          label: "Druh dokladu totožnosti",
          model: "idcard_type_id",
          formWrapperClass: "col-md-6 col-lg-3 radio-group",
          type: "radio-button",
          required: true,
          options: [
            {
              text: "OP",
              value: 2,
              icon: "id-card"
            },
            {
              text: "PAS",
              value: 1,
              icon: "passport"
            }
          ]
        },
        {
          label: "Číslo preukazu totožnosti",
          placeholder: "Zadajte číslo preukazu totožnosti",
          model: "idcard_no",
          formWrapperClass: "col-md-6 col-lg-5",
          required: true
        },
        {
          label: "Platnosť preukazu totožnosti",
          placeholder: "Vyberte dátum",
          model: "idcard_validity",
          formWrapperClass: "col-md-6 col-lg-4",
          type: "date",
          required: true
        }
      ],
      company: [
        {
          label: "Názov spoločnosti",
          placeholder: "Zadajte názov spoločnosti",
          model: "company_name",
          formWrapperClass: "col-md-12 col-lg-4",
          required: true
        },
        {
          label: "IČO",
          placeholder: "Zadajte IČO",
          model: "company_idno",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        },
        {
          label: "DIČ",
          placeholder: "Zadajte DIČ",
          model: "company_vat",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        }
      ],
      child: [
        {
          label: "Meno",
          placeholder: "Zadajte meno",
          model: "name",
          formWrapperClass: "col-md-6 col-lg-6",
          required: true
        },
        {
          label: "Priezvisko",
          placeholder: "Zadajte priezvisko",
          model: "surname",
          formWrapperClass: "col-md-6 col-lg-6",
          required: true
        },
        {
          label: "Dátum narodenia",
          placeholder: "Vyberte dátum",
          model: "birthdate",
          formWrapperClass: "col-md-6 col-lg-4",
          type: "date",
          required: true
        },
        {
          label: "Rodné číslo",
          placeholder: "Zadajte rodné číslo",
          model: "birthnumber",
          formWrapperClass: "col-md-6 col-lg-4",
          mask: "######/####",
          required: true
        },
        {
          label: "Daňová rezidencia",
          placeholder: "Vyberte daňovú rezidenciu",
          model: "tax_residence_id",
          formWrapperClass: "col-md-6 col-lg-4",
          type: "select",
          options: () => {
            return this.countries;
          },
          required: true
        }
      ],
      address: [
        {
          label: "Ulica / číslo",
          placeholder: "Zadajte ulicu",
          model: "street",
          formWrapperClass: "col-md-6 col-lg-3",
          required: true
        },
        {
          label: "Mesto",
          placeholder: "Zadajte mesto",
          model: "city",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        },
        {
          label: "PSČ",
          placeholder: "Zadajte PSČ",
          model: "zip",
          formWrapperClass: "col-md-6 col-lg-2",
          mask: "### ##",
          required: true
        },
        {
          label: "Krajina",
          placeholder: "Vyberte krajinu",
          model: "country_id",
          formWrapperClass: "col-md-6 col-lg-3",
          type: "select",
          options: () => {
            return this.countries;
          },
          // required: true
        }
      ],
      bankAccount: [
        {
          label: "Názov účtu",
          placeholder: "Zadajte názov účtu",
          model: "bank_account_owner_name",
          formWrapperClass: "col-md-6 col-lg-3",
          required: true
        },
        {
          label: "IBAN účet",
          placeholder: "Zadajte číslo účtu",
          model: "iban",
          mask: "AA## #### #### #### #### ####",
          formWrapperClass: "col-md-6 col-lg-4",
          required: true
        },
        {
          id: "swiftCode",
          label: "SWIFT / BIC",
          placeholder: "Zadajte SWIFT / BIC",
          model: "swift",
          disabled: true,
          formWrapperClass: "col-md-6 col-lg-2",
          required: false
        },
        {
          label: "Mena účtu",
          placeholder: "Vyberte menu",
          model: "bank_account_currency_id",
          formWrapperClass: "col-md-6 col-lg-3",
          type: "select",
          options: [
            {
              label: "EUR",
              value: 1
            },
            {
              label: "USD",
              value: 2
            }
          ],
          required: true
        }
      ],
      client_owner: {
        personal: [
          {
            label: "Meno",
            placeholder: "Zadajte meno",
            model: "name",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          },
          {
            label: "Priezvisko",
            placeholder: "Zadajte priezvisko",
            model: "surname",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          },
          {
            label: "Rodné číslo",
            placeholder: "Zadajte rodné číslo",
            model: "birthnumber",
            mask: "######/####",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          },
          {
            label: "Číslo preukazu totožnosti",
            placeholder: "Zadajte číslo preukazu totožnosti",
            model: "idcard_no",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          }
        ],
        address: [
          {
            label: "Ulica / číslo",
            placeholder: "Zadajte ulicu",
            model: "street",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          },
          {
            label: "Mesto",
            placeholder: "Zadajte mesto",
            model: "city",
            formWrapperClass: "col-md-6 col-lg-3",
            required: true
          },
          {
            label: "PSČ",
            placeholder: "Zadajte PSČ",
            model: "zip",
            formWrapperClass: "col-md-6 col-lg-3",
            mask: "### ##",
            required: true
          },
          {
            label: "Krajina",
            placeholder: "Zadajte krajinu",
            model: "country_id",
            formWrapperClass: "col-md-6 col-lg-3",
            type: "select",
            options: () => {
              return this.countries;
            },
            required: true
          }
        ]
      }
    };
  }
};
</script>

<style lang="scss">
.personal-info-form {
  h3 {
    font-size: 16px;
    padding-top: 5px;
    padding-bottom: 10px;
  }

  hr {
    border-top-color: #9b9c9c;
    margin-top: 20px;
  }

  p {
    font-size: 12px;
    line-height: 170%;
  }

  .radio-group {
    .btn-group-toggle {
      width: 100%;

      label {
        line-height: 23px;
        font-size: 16px;
      }
    }
  }
}
</style>
